import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import Backend from 'i18next-http-backend';
import LanguageDetector from "i18next-browser-languagedetector";
import DictionaryVI from "./locales/vi/translations.json";
import DictionaryEN from "./locales/en/translations.json";
import DictionaryCN from "./locales/cn/translations.json";
import DictionaryKM from "./locales/km/translations.json";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const lang = window.localStorage.getItem('i18n')

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: {
      vi: {
        translation: DictionaryVI,
      },
      en: {
        translation: DictionaryEN,
      },
      cn: {
        translation: DictionaryCN,
      },
      km: {
        translation: DictionaryKM,
      },
    },
    lng: !!lang ? lang : "vi",
    fallbackLng: !!lang ? lang : "vi",
    allowMissing: true,
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
